var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUntitled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7756 0 0 1.7756 500.0081 500.0081)",
    id: 558533
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8 0 0 8 0 0)",
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-32, -32)",
    d: "m 53 32 c 0 -1.116 -1.028 -2.828 -2.72 -5.515 c -0.719 -1.143 -1.705 -2.707 -1.79 -3.127 c -0.06 -0.422 0.038 -0.715 0.186 -1.159 c 0.179 -0.536 0.401 -1.203 0.321 -2.157 c -0.056 -0.666 -0.325 -1.461 -0.665 -2.468 c -0.521 -1.54 -1.162 -3.448 -1.184 -5.417 c 0.527 -0.825 0.852 -1.849 0.852 -3.157 c 0 -3.785 -4.131 -5 -17 -5 c -12.444 0 -20 1.211 -20 18 c 0 13.313 5.026 19.55 8 20.764 v 6.236 c 0 1.332 -1.585 3.451 -3.119 5.5 c -0.984 1.316 -2.002 2.677 -2.752 4.009 c -0.271 0.481 -0.101 1.091 0.38 1.362 c 0.155 0.087 0.324 0.129 0.49 0.129 c 0.349 0 0.688 -0.183 0.872 -0.509 c 0.687 -1.219 1.666 -2.527 2.612 -3.792 c 1.809 -2.418 3.517 -4.702 3.517 -6.699 v -6.189 c 1.466 -0.487 3 -2.017 3 -4.811 c 0 -0.575 -0.168 -1.219 -0.38 -2.034 c -0.273 -1.046 -0.6 -2.299 -0.619 -3.679 c 0.836 1.586 2.184 2.713 3.999 2.713 c 0.552 0 1 -0.448 1 -1 s -0.448 -1 -1 -1 c -1.873 0 -2.994 -2.529 -3 -4.981 c 0 -0.013 0 -0.025 0 -0.039 c 0.002 -0.707 0.113 -3.98 2 -3.98 c 0.534 0 0.808 0.275 1.4 1.001 c 0.686 0.844 1.626 1.999 3.6 1.999 c 2.145 0 2.703 -2.164 3.244 -4.256 c 0.533 -2.065 1.138 -4.406 3.021 -5.976 c 0.567 -0.472 1.831 -0.776 3.17 -1.099 c 1.555 -0.374 3.387 -0.82 4.861 -1.735 c 0.246 1.619 0.745 3.107 1.141 4.281 c 0.273 0.808 0.531 1.57 0.566 1.993 c 0.045 0.545 -0.074 0.904 -0.226 1.358 c -0.176 0.528 -0.395 1.185 -0.268 2.075 c 0.107 0.753 0.823 1.917 2.078 3.91 c 0.896 1.422 2.395 3.802 2.416 4.431 c -0.142 0.332 -1.592 0.839 -3.082 0.958 c -0.52 0.042 -0.921 0.476 -0.921 0.998 c 0 1.551 0.229 2.426 0.396 3.065 c 0.1 0.383 0.167 0.636 0.173 0.889 c -0.148 0.379 -0.845 0.309 -0.88 1.161 c -0.013 0.304 0.114 0.595 0.339 0.792 c 0.024 0.046 0.083 0.19 0.095 0.486 c -0.107 0.158 -0.418 0.448 -0.692 0.639 c -0.331 0.229 -0.492 0.633 -0.41 1.026 c 0.191 0.916 0.413 2.454 0.309 3.007 c -0.07 0.372 -0.175 0.934 -2.517 0.934 c -0.375 0 -0.757 -0.016 -1.139 -0.031 c -1.677 -0.069 -3.413 -0.139 -4.589 0.99 c -0.73 0.701 -1.085 1.716 -1.085 3.104 v 1.938 c 0 1.596 0.613 3.105 1.727 4.249 c 3.709 3.813 3.74 3.813 4.273 3.813 c 0.552 0 1 -0.448 1 -1 c 0 -0.367 -0.197 -0.688 -0.492 -0.861 c -0.153 -0.131 -0.797 -0.724 -3.348 -3.346 c -0.748 -0.769 -1.16 -1.782 -1.16 -2.855 v -1.938 c 0 -0.803 0.158 -1.361 0.47 -1.661 c 0.56 -0.538 1.863 -0.485 3.123 -0.435 c 0.409 0.016 0.819 0.033 1.22 0.033 c 1.863 0 4.057 -0.292 4.483 -2.566 c 0.16 -0.852 -0.047 -2.308 -0.198 -3.167 c 0.507 -0.443 1.028 -1.068 1.028 -1.768 c 0 -0.446 -0.061 -0.808 -0.153 -1.101 c 0.311 -0.339 0.59 -0.809 0.59 -1.399 c 0 -0.556 -0.112 -0.986 -0.231 -1.441 c -0.115 -0.44 -0.242 -0.925 -0.299 -1.674 c 1.554 -0.243 3.967 -0.927 3.967 -2.821 z m -13.033 -18.275 c -1.64 0.395 -3.057 0.735 -3.982 1.507 c -2.378 1.982 -3.099 4.771 -3.678 7.012 c -0.443 1.715 -0.752 2.756 -1.307 2.756 c -0.976 0 -1.394 -0.456 -2.049 -1.261 c -0.631 -0.775 -1.415 -1.739 -2.951 -1.739 c -2.414 0 -3.933 2.2 -3.998 5.76 c -1.686 3.47 -0.865 6.616 -0.318 8.712 c 0.163 0.622 0.316 1.209 0.316 1.528 c 0 2.491 -1.578 3 -1.995 3 c -0.832 -0.053 -7.005 -4.362 -7.005 -19 c 0 -15.288 6.172 -16 18 -16 c 13.183 0 15 1.442 15 3 c 0 3.045 -2.389 3.848 -6.033 4.725 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8 0 0 8 36 128)",
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-36.5, -48)",
    d: "m 46 37 c 0 -0.552 -0.448 -1 -1 -1 c -13.972 0 -18 0.98 -18 23 c 0 0.552 0.448 1 1 1 s 1 -0.448 1 -1 c 0 -21 3.072 -21 16 -21 c 0.552 0 1 -0.448 1 -1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8 0 0 8 56 144)",
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-39, -50)",
    d: "m 45 41 c 0 -0.552 -0.448 -1 -1 -1 c -11 0 -11 2.163 -11 19 c 0 0.552 0.448 1 1 1 s 1 -0.448 1 -1 c 0 -17 0 -17 9 -17 c 0.552 0 1 -0.448 1 -1 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntitled);
export default __webpack_public_path__ + "static/media/Untitled.2d904e4c1267fcd60a9547081f122717.svg";
export { ForwardRef as ReactComponent };